module.exports = __webpack_public_path__ + "static/media/campus-catering.6d5f5604.jpg";